export default "__VITE_ASSET__nfUsDXaA__"